export default __webpack_public_path__ + "static/media/img_selected-industry-healthcare.1cbb55f3.svg";